import { useState } from 'react';
import { theme } from '../../tailwind.config.js';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

/**
 * @name useMediaQuery
 * @description A React hook that detects whether a media query is true or false.
 * @param {string} queryString The media query to test against.
 * @returns {boolean} Whether the media query is true or false.
 */

type Breakpoints = keyof (typeof theme)['screens'];

export function useMediaQuery(breakpoint: Breakpoints) {
    const [isMatch, setIsMatch] = useState(false);

    useIsomorphicLayoutEffect(() => {
        const queryString = `(min-width: ${theme.screens[breakpoint]})`;
        const mediaQuery = window.matchMedia(queryString);

        function onChange() {
            setIsMatch(mediaQuery.matches);
        }

        mediaQuery.addEventListener('change', onChange, false);
        onChange();

        return () => mediaQuery.removeEventListener('change', onChange, false);
    }, [breakpoint]);

    return isMatch;
}
